import { render, staticRenderFns } from "./CFormGroup.vue?vue&type=template&id=17438f24&scoped=true&"
import script from "./CFormGroup.vue?vue&type=script&lang=js&"
export * from "./CFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17438f24",
  null
  
)

export default component.exports